<footer class="bd_ftr">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <figure class="footer-logo">
            <img src="assets/img/logo-main.png" alt="Logo">
          </figure>
        </div>
        <div class="col-md-2">
          <h3>Quick Links</h3>
          <ul class="footer-nave">
            <li><a routerLink="about-us">About Us</a></li>
            <li><a routerLink="services">Our Services</a></li>
            <li><a routerLink="how-it-works">How it works</a></li>
            <li><a routerLink="highlights">Highlights</a></li>
            <li><a routerLink="associates">Associates</a></li>
            <li><a routerLink="terms-conditions">Terms & Condition</a></li>
            <li><a routerLink="privacy-policy">Privacy Policy</a></li>


          </ul>
        </div>
        <div class="col-md-4 pr-md-4">
          <h3>Contact Us</h3>
          <ul class="footer-contactus">
            <li *ngIf="this.siteSettings?.conact_address"><img src="assets/img/location.png" alt="location">
              {{
              this.siteSettings?.conact_address }}</li>
            <li *ngIf="this.siteSettings?.conact_mobile"><img src="assets/img/call.png" alt="location"><a
                href="tel:{{ this.siteSettings?.conact_mobile }}">{{
                this.siteSettings?.conact_mobile }}</a></li>
            <li *ngIf="this.siteSettings?.conact_mobile_2"><img src="assets/img/call.png" alt="location"><span><a
                  href="tel:{{ this.siteSettings?.conact_mobile_2 }}">{{
                  this.siteSettings?.conact_mobile_2 }}</a></span></li>
            <li *ngIf="this.siteSettings?.conact_email"><img src="assets/img/email.png" alt="location"><span><a
                  href="mailto:{{ this.siteSettings?.conact_email }}">{{
                  this.siteSettings?.conact_email }}</a></span></li>
          </ul>
        </div>
        <div class="col-md-3">
          <h3>Follow us</h3>
          <ul class="footer-sochal">
            <ng-container *ngIf="social_links?.length;else socialLinkNotFound">
              <li *ngFor="let social of social_links"><a [href]="social?.link" target="_blank">
                  <img [src]="social?.icon_path" width="37" alt="">
                </a></li>
            </ng-container>
            <ng-template #socialLinkNotFound>

            </ng-template>

          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-copy">
    <div class="container">
      Copyright © {{ date.getUTCFullYear() }} Tea Inntech. All rights reserved.
      <!-- Copyright © {{ date.getUTCFullYear() }} Tea InnTech -->
    </div>
  </div>

  <!-- <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="ftr_link">
                    <span *ngFor="let item of footermenu">
                        <a class="nav-link" [routerLink]="item.href">{{item.label}}</a>
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="bd_copy">
                    Copyright © {{ date.getUTCFullYear() }} Tea Inntech. All rights reserved.
                </div>
            </div>
        </div>
    </div> -->
</footer>
